/* <main-product-offer> — sections/main-product-offer.liquid behaviour (Shrine port, 2026-10-13):
   gallery slider + thumbnails, accordion rows, image popup, offer tiers (price row, ATC label, form quantity),
   optional variant picker (hidden `id` input + tier prices recomputed from the chosen variant), UGC and
   testimonial sliders, sticky bar. Adding to cart is Shrine's own <product-form> (assets/product-form.js). */
(function () {
  'use strict';
  if (customElements.get('main-product-offer')) return;

  function swipe(el, onDir) {
    var startX = null;
    el.addEventListener('pointerdown', function (e) { startX = e.clientX; });
    el.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) onDir(dx < 0 ? 1 : -1);
    });
    el.addEventListener('pointercancel', function () { startX = null; });
  }

  /* Shopify money format ("${{amount}}", "{{amount_with_comma_separator}} €", …) → string. cents is an integer. */
  function formatMoney(cents, format) {
    var f = (format && format.indexOf('{{') !== -1) ? format : '${{amount}}';
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    function sep(n, thousands, decimal, places) {
      var neg = n < 0;
      var fixed = (Math.abs(n) / 100).toFixed(places).split('.');
      fixed[0] = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return (neg ? '-' : '') + (fixed.length > 1 ? fixed[0] + decimal + fixed[1] : fixed[0]);
    }
    var value;
    switch (key) {
      case 'amount_no_decimals': value = sep(cents, ',', '.', 0); break;
      case 'amount_with_comma_separator': value = sep(cents, '.', ',', 2); break;
      case 'amount_no_decimals_with_comma_separator': value = sep(cents, '.', ',', 0); break;
      case 'amount_with_apostrophe_separator': value = sep(cents, "'", '.', 2); break;
      case 'amount_with_space_separator': value = sep(cents, ' ', ',', 2); break;
      case 'amount_no_decimals_with_space_separator': value = sep(cents, ' ', ',', 0); break;
      default: value = sep(cents, ',', '.', 2);
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  customElements.define(
    'main-product-offer',
    class MainProductOffer extends HTMLElement {
      connectedCallback() {
        this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
        this.initGallery();
        this.initRows();
        this.initPopup();
        this.initOffers();
        this.initVariants();
        this.initUgc();
        this.initTestimonials();
        this.initSticky();
      }

      /* ---------------------------------------------------------------- gallery */
      initGallery() {
        var list = this.querySelector('[data-gallery-list]');
        if (!list) return;
        var slides = list.querySelectorAll('[data-gallery-slide]');
        var thumbs = this.querySelectorAll('[data-thumb]');
        var thumbList = this.querySelector('[data-thumb-list]');
        var prev = this.querySelector('[data-gallery-prev]');
        var next = this.querySelector('[data-gallery-next]');
        var index = 0;
        var self = this;
        function go(n) {
          index = Math.max(0, Math.min(slides.length - 1, n));
          /* slides sit off-screen horizontally, so force the target (and its neighbours) to load now */
          for (var k = index - 1; k <= index + 1; k++) { var im = slides[k] && slides[k].querySelector('img'); if (im && im.loading === 'lazy') im.loading = 'eager'; }
          list.style.transform = 'translateX(calc(-' + index + ' * (100% + 4px)))';
          slides.forEach(function (s, i) { if (i === index) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true'); });
          thumbs.forEach(function (t, i) {
            t.classList.toggle('is-active', i === index);
            var b = t.querySelector('[data-thumb-button]');
            if (b) { if (i === index) b.setAttribute('aria-pressed', 'true'); else b.removeAttribute('aria-pressed'); }
          });
          if (prev) prev.disabled = index === 0;
          if (next) next.disabled = index === slides.length - 1;
          var active = thumbs[index];
          if (thumbList && active) thumbList.scrollTo({ left: active.offsetLeft - thumbList.clientWidth / 2 + active.clientWidth / 2, behavior: 'smooth' });
          self.galleryIndex = index;
        }
        this.goToMedia = function (mediaId) {
          if (!mediaId) return;
          for (var i = 0; i < slides.length; i++) { if (slides[i].dataset.mediaId === String(mediaId)) { go(i); return; } }
        };
        if (prev) prev.addEventListener('click', function () { go(index - 1); });
        if (next) next.addEventListener('click', function () { go(index + 1); });
        thumbs.forEach(function (t, i) { var b = t.querySelector('[data-thumb-button]'); if (b) b.addEventListener('click', function () { go(i); }); });
        var tp = this.querySelector('[data-thumbs-prev]');
        var tn = this.querySelector('[data-thumbs-next]');
        if (tp && thumbList) tp.addEventListener('click', function () { thumbList.scrollBy({ left: -234, behavior: 'smooth' }); });
        if (tn && thumbList) tn.addEventListener('click', function () { thumbList.scrollBy({ left: 234, behavior: 'smooth' }); });
        var main = this.querySelector('[data-gallery-main]');
        if (main) swipe(main, function (dir) { go(index + dir); });
        go(0);
      }

      /* ---------------------------------------------------------------- accordion rows */
      initRows() {
        this.querySelectorAll('[data-row]').forEach(function (row) {
          var btn = row.querySelector('[data-row-toggle]');
          var panel = row.querySelector('[data-row-panel]');
          if (!btn || !panel) return;
          btn.addEventListener('click', function () {
            var open = row.classList.contains('is-open');
            if (open) {
              panel.style.height = panel.scrollHeight + 'px';
              requestAnimationFrame(function () { panel.style.height = '0px'; });
              row.classList.remove('is-open');
              btn.setAttribute('aria-expanded', 'false');
              panel.addEventListener('transitionend', function done() { panel.hidden = true; panel.style.height = ''; panel.removeEventListener('transitionend', done); });
            } else {
              panel.hidden = false;
              panel.style.height = '0px';
              requestAnimationFrame(function () { panel.style.height = panel.scrollHeight + 'px'; });
              row.classList.add('is-open');
              btn.setAttribute('aria-expanded', 'true');
              panel.addEventListener('transitionend', function done() { panel.style.height = ''; panel.removeEventListener('transitionend', done); });
            }
          });
        });
      }

      /* ---------------------------------------------------------------- popup */
      initPopup() {
        var dialog = this.querySelector('[data-popup]');
        if (!dialog) return;
        this.querySelectorAll('[data-popup-open]').forEach(function (b) { b.addEventListener('click', function () { if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', ''); }); });
        dialog.querySelectorAll('[data-popup-close]').forEach(function (b) { b.addEventListener('click', function () { dialog.close(); }); });
        dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
      }

      /* ---------------------------------------------------------------- offer tiers */
      initOffers() {
        var self = this;
        var offers = this.querySelectorAll('[data-offer]');
        var priceNow = this.querySelector('[data-price-now]');
        var priceCompare = this.querySelector('[data-price-compare]');
        var priceBadge = this.querySelector('[data-price-badge]');
        var buyPrice = this.querySelector('[data-buy-price]');
        var buyCompare = this.querySelector('[data-buy-compare]');
        var qtyInput = this.querySelector('[data-offer-quantity]');
        this.selectedOffer = null;
        function select(offer) {
          self.selectedOffer = offer;
          offers.forEach(function (o) { o.classList.toggle('is-selected', o === offer); });
          var showCompare = offer.dataset.showCompare === 'true';
          if (priceNow) priceNow.textContent = offer.dataset.price;
          if (priceCompare) { priceCompare.textContent = offer.dataset.compare; priceCompare.hidden = !showCompare; }
          if (buyPrice) buyPrice.textContent = offer.dataset.price;
          if (buyCompare) { buyCompare.textContent = offer.dataset.compare; buyCompare.hidden = !showCompare; }
          if (priceBadge) priceBadge.hidden = offer.dataset.popular !== 'true';
          if (qtyInput) qtyInput.value = offer.dataset.quantity || '1';
          self.dispatchEvent(new CustomEvent('mpo:offer', { detail: { quantity: Number(offer.dataset.quantity || 1) } }));
        }
        this.selectOffer = select;
        if (!offers.length) return;
        offers.forEach(function (o) {
          var radio = o.querySelector('[data-offer-radio]');
          if (radio) radio.addEventListener('change', function () { if (radio.checked) select(o); });
        });
        var checked = this.querySelector('[data-offer-radio]:checked');
        if (checked) select(checked.closest('[data-offer]'));
      }

      /* Recompute every tier from a variant's unit price (cents). Mirrors the Liquid:
         price = unit × (qty − free) × (1 − pct/100) − fixed ; compare = max(compare_at, unit) × qty. */
      recomputeOffers(unit, compareAt) {
        var self = this;
        var compareUnit = compareAt > unit ? compareAt : unit;
        this.querySelectorAll('[data-offer]').forEach(function (o) {
          var qty = Math.max(1, parseInt(o.dataset.quantity, 10) || 1);
          var free = Math.max(0, parseInt(o.dataset.free, 10) || 0);
          var pct = parseFloat(o.dataset.percent) || 0;
          var fixed = parseInt(o.dataset.fixed, 10) || 0;
          var paid = Math.max(1, qty - free);
          var price = Math.max(0, Math.round(unit * paid * (1 - pct / 100) - fixed));
          var compare = compareUnit * qty;
          var each = Math.round(price / qty);
          var save = Math.max(0, compare - price);
          var fmt = function (c) { return formatMoney(c, self.moneyFormat); };
          o.dataset.price = fmt(price);
          o.dataset.compare = fmt(compare);
          o.dataset.showCompare = compare > price ? 'true' : 'false';
          var p = o.querySelector('[data-offer-price]'); if (p) p.textContent = fmt(price);
          var c = o.querySelector('[data-offer-compare]'); if (c) { c.textContent = fmt(compare); c.hidden = !(compare > price); }
          var s = o.querySelector('[data-offer-sub]'); if (s && o.dataset.saveTemplate) s.textContent = o.dataset.saveTemplate.replace('[amount]', fmt(save));
          var u = o.querySelector('[data-offer-unit]'); if (u && o.dataset.unitTemplate) u.textContent = o.dataset.unitTemplate.replace('[price]', fmt(each));
        });
        if (this.selectedOffer && this.selectOffer) this.selectOffer(this.selectedOffer);
      }

      /* ---------------------------------------------------------------- variant picker (optional) */
      initVariants() {
        var self = this;
        var root = this.querySelector('[data-variants]');
        if (!root) return;
        var idInput = this.querySelector('[data-variant-id-input]');
        var button = this.querySelector('button[name="add"]');
        var buyText = this.querySelector('[data-buy-text]');
        function apply(opt) {
          if (!opt) return;
          var unit = parseInt(opt.dataset.price, 10) || 0;
          var compareAt = parseInt(opt.dataset.compare, 10) || 0;
          var available = opt.dataset.available === 'true';
          if (idInput) { idInput.value = opt.value; idInput.disabled = !available; }
          if (button) {
            button.disabled = !available;
            if (buyText) buyText.textContent = available ? (button.dataset.atcLabel || buyText.textContent) : (button.dataset.soldOutLabel || 'Sold out');
          }
          root.querySelectorAll('[data-variant-pill]').forEach(function (pill) {
            var r = pill.querySelector('[data-variant-radio]');
            pill.classList.toggle('is-selected', !!(r && r.checked));
          });
          self.recomputeOffers(unit, compareAt);
          if (self.goToMedia && opt.dataset.mediaId) self.goToMedia(opt.dataset.mediaId);
          self.dispatchEvent(new CustomEvent('mpo:variant', { detail: { id: opt.value, available: available } }));
        }
        var select = root.querySelector('[data-variant-select]');
        if (select) {
          select.addEventListener('change', function () { apply(select.options[select.selectedIndex]); });
        }
        root.querySelectorAll('[data-variant-radio]').forEach(function (r) {
          r.addEventListener('change', function () { if (r.checked) apply(r); });
        });
      }

      /* ---------------------------------------------------------------- loop sliders */
      loopSlider(opts) {
        var list = opts.list; if (!list) return;
        var items = list.children; var n = items.length; if (!n) return;
        var index = 0;
        function go(i) {
          index = ((i % n) + n) % n;
          list.style.transform = 'translateX(calc(-' + index + ' * ' + opts.step + '))';
          for (var k = 0; k < n; k++) {
            var visible = k >= index && k < index + (opts.visible || 1);
            if (visible) items[k].removeAttribute('aria-hidden'); else items[k].setAttribute('aria-hidden', 'true');
          }
          if (opts.dots) opts.dots.querySelectorAll('button').forEach(function (d, k) { d.classList.toggle('is-active', k === index); d.setAttribute('aria-selected', k === index ? 'true' : 'false'); });
        }
        if (opts.dots) {
          opts.dots.innerHTML = '';
          for (var i = 0; i < n; i++) {
            var d = document.createElement('button');
            d.type = 'button'; d.className = 'mpo__dot'; d.setAttribute('role', 'tab'); d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            d.addEventListener('click', (function (k) { return function () { go(k); }; })(i));
            opts.dots.appendChild(d);
          }
        }
        if (opts.prev) opts.prev.addEventListener('click', function () { go(index - 1); });
        if (opts.next) opts.next.addEventListener('click', function () { go(index + 1); });
        if (opts.track) swipe(opts.track, function (dir) { go(index + dir); });
        go(0);
      }

      initUgc() {
        var root = this.querySelector('[data-ugc]'); if (!root) return;
        this.loopSlider({ list: root.querySelector('[data-ugc-list]'), track: root.querySelector('[data-ugc-track]'), prev: root.querySelector('[data-ugc-prev]'), next: root.querySelector('[data-ugc-next]'), step: '(19.2rem + 1.2rem)', visible: 3 });
      }

      initTestimonials() {
        var root = this.querySelector('[data-tslider]'); if (!root) return;
        this.loopSlider({ list: root.querySelector('[data-ts-list]'), track: root.querySelector('[data-ts-track]'), prev: root.querySelector('[data-ts-prev]'), next: root.querySelector('[data-ts-next]'), dots: root.querySelector('[data-ts-dots]'), step: '(100% + 1.6rem)', visible: 1 });
      }

      /* ---------------------------------------------------------------- sticky bar: shown once the Add-to-cart button has scrolled above the viewport */
      initSticky() {
        var bar = this.querySelector('[data-sticky]'); if (!bar) return;
        var target = this.querySelector('button[name="add"]') || this;
        var ticking = false;
        function update() { var v = target.getBoundingClientRect().bottom < 0; bar.classList.toggle('is-visible', v); bar.setAttribute('aria-hidden', v ? 'false' : 'true'); ticking = false; }
        function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        update();
      }
    }
  );
})();
